import React from "react";

import {ScreenSpinner, SplitCol, SplitLayout} from "@vkontakte/vkui";
import {Placemark, YMaps, Map, ZoomControl, TypeSelector, FullscreenControl} from "@pbe/react-yandex-maps";
import SalePointsApi from "../api/references/salePoints"
import {formatDateTime, getSalePointsTypes, inducement, YMAPS_API_KEY} from "../assets/constants";

import "./style.css"
import {createPie} from "../assets/RadialDiagrammSVG";
import {hasGroupTypeStats, STANDS_SHARE_MESSAGE, standsShareBalloonButtonHtml} from "./standsShare";

class BaseMap extends React.Component {

    state = {
        items: [],
        popout: null,
    }


    constructor() {
        super();
        this.mapRef = React.createRef()
        this.types = getSalePointsTypes()
        this.placemarkRefs = {}
        this.standsShareByToken = {}
    }


    showSpinner = () => {
        this.setState({popout: <ScreenSpinner state="loading"/>})
    }

    showDoneSpinner = () => {
        this.setState({popout: <ScreenSpinner state="done"/>})
        setTimeout(() => this.clearSpinner(), 1500)
    }

    clearSpinner = () => {
        this.setState({popout: null})
    }


    handleMouseEnter = (e) => {
        const {options} = e.originalEvent.target
        options.set('iconImageHref', options.get('iconImageHover'))
    };

    handleMouseLeave = (e) => {
        const {options} = e.originalEvent.target
        options.set('iconImageHref', options.get('iconImage'))

    };

    handleStandsShareBtnClick = (e) => {
        const btn = e.target && e.target.closest && e.target.closest('.stands-share-balloon-btn')
        if (!btn) return
        e.preventDefault()
        e.stopPropagation()
        const token = btn.getAttribute('data-stands-share-token')
        const item = this.standsShareByToken[token]
        if (!item) return
        const title = item.title || (item.klient && item.klient.title) || 'Доля видов стендов'
        window.postMessage({
            type: STANDS_SHARE_MESSAGE,
            title,
            groupTypeStats: item.groupTypeStats || null,
        })
    }

    registerStandsShareToken = (token, item) => {
        this.standsShareByToken[token] = item
    }

    getStandsShareBalloonButton = (token, item) => {
        if (!hasGroupTypeStats(item && item.groupTypeStats)) return ''
        this.registerStandsShareToken(token, item)
        return standsShareBalloonButtonHtml(token)
    }

    getItems = () => {
        this.showSpinner()
        SalePointsApi.getAllSalePoints({date: formatDateTime(this.props.date)}).then(response => {
            const {items} = response.data
            if (items) {

                this.showDoneSpinner()
                this.setState({items})
                setTimeout(() => this.mapGetBounds(), 500)
            }
        })
    }
    mapGetBounds = () => {
        if (this.mapRef && this.mapRef.current && this.state.items) {
            const mapBounds = this.state.items.reduce(
                (bounds, point) => {
                    return [
                        [
                            Math.min(bounds[0][0], point.mapX),
                            Math.min(bounds[0][1], point.mapY),
                        ],
                        [
                            Math.max(bounds[1][0], point.mapX),
                            Math.max(bounds[1][1], point.mapY),
                        ],
                    ];
                },
                [
                    [Infinity, Infinity],
                    [-Infinity, -Infinity],
                ]
            )

            this.mapRef.current.setBounds(mapBounds, {
                checkZoomRange: true,
                zoomMargin: 20,
            })
        }
    }

    centerOnPoint = (point) => {
        const map = this.mapRef && this.mapRef.current
        if (!map || !point) {
            return
        }

        const isMall = point.isMall == 1 || point.isMall === true
        const mallId = point.mall_id ? Number(point.mall_id) : 0
        const markerId = (!isMall && mallId > 0) ? mallId : point.id

        const coords = this.resolvePointCoords(point)
        const applyFocus = () => {
            if (map.container && typeof map.container.fitToViewport === 'function') {
                map.container.fitToViewport()
            }
            if (coords) {
                map.setCenter(coords, 16, {
                    duration: 300,
                    checkZoomRange: true,
                })
            }
            this.openPlacemarkBalloon(markerId)
        }

        applyFocus()
        setTimeout(applyFocus, 350)
    }

    resolvePointCoords = (point) => {
        const own = this.toLatLon(point.mapY, point.mapX)
        if (own) {
            return own
        }
        return this.toLatLon(point.mall_mapY, point.mall_mapX)
    }

    toLatLon = (lat, lon) => {
        const y = Number(lat)
        const x = Number(lon)
        if (!Number.isFinite(y) || !Number.isFinite(x)) {
            return null
        }
        if (y === 0 && x === 0) {
            return null
        }
        return [y, x]
    }

    openPlacemarkBalloon = (markerId, attempt = 0) => {
        const placemark = this.placemarkRefs[markerId] || this.placemarkRefs[String(markerId)]
        if (placemark && placemark.balloon) {
            Object.keys(this.placemarkRefs).forEach((id) => {
                const other = this.placemarkRefs[id]
                if (other && other !== placemark && other.balloon && other.balloon.isOpen()) {
                    other.balloon.close()
                }
            })
            placemark.balloon.open()
            return
        }
        if (attempt < 10) {
            setTimeout(() => this.openPlacemarkBalloon(markerId, attempt + 1), 200)
        }
    }

    componentDidMount() {
        this.getItems()
        document.addEventListener('click', this.handleStandsShareBtnClick, true)
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleStandsShareBtnClick, true)
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (formatDateTime(prevProps.date) != formatDateTime(this.props.date)) {
            this.getItems()
        }
    }

    render() {

        const location = {center: [54.7750, 56.0375,], zoom: 9, behaviors: ['drag', 'pinchZoom', 'mouseTilt']}

        return (
            <SplitLayout popout={this.state.popout}>
                <SplitCol>
                    <YMaps query={{
                        load: "package.full",
                        apikey: YMAPS_API_KEY
                    }}>
                        <Map defaultState={{center: [54.7750, 56.0375], zoom: 9, controls: []}}
                             width={"100%"}
                             height={"93vh"}
                             instanceRef={(map) => {
                                 this.mapRef.current = map; // сохраняем ссылку на объект карты
                             }}>
                            {this.state.items.map((salePoint, index) => {
                                const image = salePoint.images[0]
                                const image2 = salePoint.images[1]
                                const cnt_sp = salePoint.isMall == 1 ?
                                    (salePoint.sale_points_cnt > 0 ? salePoint.sale_points_cnt : 'Нет')
                                    + ' ' + (inducement(salePoint.sale_points_cnt, 'торговая точка', 'торговые точки', 'торговых точек')) : ''


                                const {foundCnt, competitorCnt} = salePoint

                                const total = foundCnt + competitorCnt
                                const competitorsPercent = Math.round(competitorCnt / total * 100)

                                const config = {strokeWidth: 60, radius: 30, start: "0"}
                                const pie = createPie([{
                                        value: 100 - competitorsPercent,
                                        color: "blue"
                                    }, {
                                        value: competitorsPercent,
                                        color: competitorsPercent || total ? "red" : "#dadada"
                                    },],
                                    config)
                                const pieHover = createPie([{
                                        value: 100 - competitorsPercent,
                                        color: competitorsPercent || total ? "#4d4dfb" : "#e5e2e2"
                                    }, {
                                        value: competitorsPercent,
                                        color: competitorsPercent || total ? "#ff7070" : "#e5e2e2"
                                    },],
                                    config)

                                const shareBtn = this.getStandsShareBalloonButton(`sp-${salePoint.id}`, salePoint)

                                const baloonHtml = `<div >
                                                    <h3>${salePoint.klient ? salePoint.klient.title : ''}</h3> 
                                                    <p>${this.types[salePoint.type_]} <b>${salePoint.title}</b></p>
                                                    <div style="display: flex">
                                                        ${image ? `<img class="map-avatar" width="128" src="${image.thumb}" />` : ''}
                                                        ${image2 ? `<img class="map-avatar" width="128" src="${image2.thumb}" />` : ''}
                                                        ${pie ? `<img class="map-avatar" width="100" src="${`data:image/svg+xml;charset=UTF-8,${encodeURIComponent(pie)}`}" />` : ''}
                                                    </div>
                                                    <div>${cnt_sp}</div>
                                                    <div style="color: blue">Всего:${total ?? 'Не известно'} Наши:${foundCnt ?? 'Не известно'} Конкуренты:${competitorCnt ?? 'Не известно'}</div>
                                                    <div style="color: blue">Наши стенды: ${competitorsPercent || total ? 100 - competitorsPercent : 'Не известно'}%</div>
                                                    <div style="color: red">Конкуренты: ${competitorsPercent || total ? competitorsPercent : 'Не известно'}%</div>
                                                    ${shareBtn}
                                                </div>`
                                return <Placemark

                                    key={index}
                                    geometry={[salePoint.mapY, salePoint.mapX,]}
                                    instanceRef={(ref) => {
                                        if (ref) this.placemarkRefs[salePoint.id] = ref
                                    }}
                                    options={{
                                        iconLayout: 'default#image',
                                        iconImageHref: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(pie)}`,
                                        iconImage: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(pie)}`,
                                        iconImageHover: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(pieHover)}`,
                                        iconImageSize: [70, 70],
                                        iconImageOffset: [-35, -35],

                                    }}
                                    properties={{
                                        hideIconOnBalloonOpen: false,
                                        hintContent: `${salePoint.klient ? salePoint.klient.title : ''} ${this.types[salePoint.type_]} ${salePoint.title}`,
                                        balloonContent: baloonHtml,
                                    }}
                                    modules={['geoObject.addon.hint', 'geoObject.addon.balloon']}
                                    onClick={(e) => this.setCurrentSalePoint(e, salePoint)}
                                    onMouseEnter={this.handleMouseEnter}
                                    onMouseLeave={this.handleMouseLeave}
                                    baloonClose={(e) => console.log(e)}

                                />
                            })}
                            <ZoomControl options={{float: "left"}}/>
                            <TypeSelector options={{float: "right"}}/>
                            <FullscreenControl/>
                        </Map>
                    </YMaps>
                </SplitCol>
            </SplitLayout>
        )
    }

    setCurrentSalePoint = (e, salePoint) => {
        /*  e.originalEvent.target.balloon.close()
          e.originalEvent.target.balloon.open()
  */
        this.props.setCurrentSalePoint(salePoint)

    }
}

export default BaseMap
